import { HTTP_INTERCEPTORS, HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Router } from "@angular/router";
import { throwError } from "rxjs";
import { catchError } from "rxjs/operators";

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
    constructor(private router: Router) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError((error) => {
                //All routes are defined as /<componentname>/action/lang/other parameters
                //Optout is defined as /optout/lang/other params
                let lang = 'en-US';
                let action = 'all';
                var navParams = this.router.url.split('/', 4);
                if (navParams !== undefined && navParams !== null && navParams.length > 1) {
                    if (navParams[1].toLowerCase() === 'optout') {
                        action = navParams[1];
                        if (navParams.length > 2) {
                            lang = navParams[2];
                        }
                    } else if (navParams.length > 3) {
                        action = navParams[2];
                        lang = navParams[3];
                    }
                }
                if (error instanceof HttpErrorResponse && error.status == 404 && this.fromCustomerService(req)) {   
                    let errorRef = error.error ? error.error : '';
                    this.router.navigateByUrl(`/error/notfound/${action}/${lang}/${errorRef}`);
                    return new Observable<HttpEvent<typeof error>>();
                }
                else if (error instanceof HttpErrorResponse && (error.status >= 500)) {
                    this.router.navigateByUrl(`/error/maintenance/${lang}`);
                    return throwError(error);
                }
                else {
                    this.router.navigateByUrl(`/error/${action}/${lang}`);
                    return throwError(error);
                }
            })
        );
    }

    fromCustomerService(req: HttpRequest<any>) {
        let requestUrl = req.url;
        if (requestUrl.includes('customer/find') || requestUrl.includes('customer/getDetails')) {
            return true;
        }
        return false;
    }
}